export default {
    hovered_item: undefined,
    sub_item: undefined,
    inital_height: 0,
    init() {
        console.log('menu has loaded!');
        let burger = document.getElementById('burger');
        let burger_sticky = document.getElementById('burger-sticky')
        let exit = document.getElementById('exit');
        let menu = document.getElementById('menu');
        
        //enable to show underlines.
        // this.init_underline();
        
        exit.addEventListener('click', () => {
            menu.classList.toggle('menu-active')
            // this.toggle_animation(false)
        });

        if(burger_sticky) {
            burger_sticky.addEventListener('click', () => {
                menu.classList.toggle('menu-active')
                this.inital_active_item();
                this.menu_hover();
                // this.toggle_animation(true)
            });
        }

        if(burger) {
            burger.addEventListener('click', (e) => {
                // console.log('menu has been clicked :)')
                menu.classList.toggle('menu-active')
                this.inital_active_item();
                this.menu_hover();
                // this.toggle_animation(true);
                //enable to show underlines.
                // this.underline_width();
            })
        }
    },

    /**
     * Initialising underline.
     */
    init_underline() {
        let menu_items = document.querySelectorAll('#menu .menu-item');
        if(menu_items.length > 0) {
            let colour_count = 0;
            let colours = ["green", 'yellow', 'pink', 'violet', 'red', 'blue'];
            for(let i = 0; i < menu_items.length; i++) {
                let menu_item = menu_items[i];
                //if this is not a sub menu item add an underline.
                if(!menu_item.parentElement.classList.contains('sub-menu')) {
                    let line_div = document.createElement("DIV");
                    line_div.classList.add('menu-underline');
                    line_div.innerHTML = `<svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 185 5"><defs><style>.underline-wiggle{fill:none;stroke:#484f83;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.6px;}</style></defs><title>Underline Wiggle</title><g id="Layer_22" data-name="Layer 22"><path class="underline-wiggle" d="M1,.92C22.9,4.1,18.48,3.15,64.89,2S121.22,6.79,184,2"/></g></svg>`;
                    menu_item.appendChild(line_div);
                    if(colour_count < colours.length) {
                        line_div.classList.add(colours[colour_count]);
                        colour_count++;
                    } else {
                        colour_count = 0;
                        line_div.classList.add(colours[colour_count]);
                        colour_count++;
                    }
                }
            }
        }
    },

    /** Sets widht of the underline to be the same as the anchor tag width. */
    underline_width() {
        let menu_items = document.querySelectorAll('#menu .menu-item');
        if(menu_items.length > 0) {
            for(let i = 0; i < menu_items.length; i++) {
                let anchor = menu_items[i].getElementsByTagName('a')[0];
                // let underline = menu_items[i].querySelector(':scope > .menu-underline');
                let children = menu_items[i].children;

                let underline;
                for(let i = 0; i < children.length; i++) {
                    if(children[i].classList.contains('menu-underline')) {
                        underline = children[i];
                    }
                }
                //if not a sub menu.
                if(underline) {
                    let width = anchor.offsetWidth + "px";
                    underline.style.width = width;
                }
            }
        }
    },

    /**
     * Function that performs or hides an animation if the menu is opened or closed.
     * @param {boolean} toggle Whether to perform the animation or remove it.
     */
    toggle_animation(toggle) {

        let primary_menu = document.getElementById('menu-primary-navigation');
        //if the page contains a primary menu.
        if(primary_menu) {
            //getting all the links in the menu
            let links = primary_menu.querySelectorAll('.menu-item a');

            //if the page contains any links
            if(links.length > 0) {
                let animation_count = 0;
                for(let i = 0; i < links.length; i++) {
                    let link = links[i];
                    if(link.parentElement.parentElement.id !== "sub-menu" && !link.parentElement.parentElement.classList.contains('sub-menu')) {
                        if(toggle) {
                            $(link).css('animation-delay', (0.1 * animation_count) + 's');
                            // link.style.animationDelay = 0.1 * i;
                            link.classList.add('navigation-animation');
                        } else {
                            link.removeAttribute('style');
                            link.classList.remove('navigation-animation');
                        }
                        animation_count++;
                    }
                }
            }

            /** Adding animations to all the sub menus. */
            let sub_menus = primary_menu.getElementsByClassName('sub-menu');

            //if we have any sub menus
            if(sub_menus.length > 0) {
                for (let i = 0; i < sub_menus.length; i++) {
                    const sub_menu = sub_menus[i];
                    
                    //getting links for a given sub menu
                    let sub_links = sub_menu.querySelectorAll('.menu-item a');
                    //if the sub menu has any links
                    if(sub_links) {
                        for (let i = 0; i < sub_links.length; i++) {
                            const sub_link = sub_links[i];
                            if(toggle) {
                                $(sub_link).css('animation-delay', (0.1 * i) + 's');
                                // link.style.animationDelay = 0.1 * i;
                                sub_link.classList.add('navigation-animation');
                            } else {
                                sub_link.removeAttribute('style');
                                sub_link.classList.remove('navigation-animation');
                            }
                        }
                    }
                }
            }
        }
    },

    inital_active_item() {
        let current = document.getElementsByClassName('current-menu-item');
        if(current.length > 0) {
            this.inital_height = document.getElementById('menu-primary-navigation').offsetHeight;
            if(current[0].parentElement.classList.contains('sub-menu')) {
                let sub_menu_item = current[0].parentElement.parentElement
                this.hovered_item = sub_menu_item;
                console.log("Sub menu item: ", sub_menu_item);
                sub_menu_item.getElementsByTagName('a')[0].classList.add('menu-item__active');
                this.hovered_item.classList.add('menu-item__active');
                this.sub_item = current[0];

                this.render_sub_menu();
                this.calculate_sub_menu_height();
            } else {
                this.hovered_item = current[0];
                current[0].getElementsByTagName('a')[0].classList.add('menu-item__active');
            }
            // if(current[0].classList.contains('current_page_ancestor')) {
            //     this.parentElement = current[0];
            //     let sub_menu = current[0].getElementsByClassName('sub-menu')[0];
            //     let sub_menu_item = sub_menu.getElementsByClassName('current-menu-item')[0];
            //     this.sub_item = sub_menu_item;
            // }
        }
    },
    menu_hover(type = "menu") {

        let menu_id = (type === "menu") ? 'menu-primary-navigation' : 'sub-menu';

        let menu = document.getElementById(menu_id);

        let menu_items = menu.getElementsByClassName('menu-item');
        if(menu_items.length > 0) {
            this.inital_height = document.getElementById('menu-primary-navigation').offsetHeight;
            let that = this;
            for(let i = 0; i < menu_items.length; i++) {
                let menu_item = menu_items[i];
                menu_item.addEventListener('mouseover', function(e) {
                    console.log("Link has been hovered!");
                    menu_item.getElementsByTagName('a')[0].classList.add('menu-item__active');
                    if(type === "menu") {
                        that.hovered_item = this;
                    } else {
                        that.sub_item = this;
                    }
                    that.remove_active_links(type, menu);

                    if(type === "menu") {
                        that.render_sub_menu();
                        that.underline_width();
                        that.calculate_sub_menu_height();
                    }
                });
            }
        }
    },
    remove_active_links(type, menu) {
        let menu_items = menu.getElementsByClassName('menu-item');
        if(menu_items.length > 0) {
            for(let i = 0; i < menu_items.length; i++) {
                let menu_item = menu_items[i];

                if(type === 'menu' && menu_item !== this.hovered_item) {
                    menu_item.getElementsByTagName('a')[0].classList.remove('menu-item__active');

                } else if (type === 'sub-menu' && menu_item !== this.sub_item) {
                    menu_item.getElementsByTagName('a')[0].classList.remove('menu-item__active');
                }
                // if(!menu_item.parentElement.classList.contains('sub-menu') && menu_item !== this.hovered_item) {
                //     menu_item.getElementsByTagName('a')[0].classList.remove('menu-item__active');
                // }
            }
        }
    },
    render_sub_menu() {
        let sub_menu_holder = document.getElementById('sub-menu');
        if(this.hovered_item.classList.contains('menu-item-has-children')) {
            let sub_menu = this.hovered_item.getElementsByClassName('sub-menu')[0];

            if(this.sub_item) {
                this.sub_item.getElementsByTagName('a')[0].classList.add('menu-item__active');
            }

            let sub_menu_clone = sub_menu.cloneNode(true);
            sub_menu_holder.innerHTML = '';
            sub_menu_holder.appendChild(sub_menu_clone);
            this.menu_hover('sub-menu');
        } else {
            sub_menu_holder.innerHTML = '';
        }
    },
    calculate_sub_menu_height() {
        let sub_menu_holder = document.getElementById('sub-menu');
        const margin_amount = 25;
        // let primary_menu = document.getElementById('menu-active__links');

        if(sub_menu_holder) {
            // let menu_height = primary_menu.offsetHeight;
            sub_menu_holder.style.maxHeight = this.inital_height + margin_amount + "px";
        }
    }
}